import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

// UPDATE SUB-CHANNEL SALES REPS
export const updateSubChannelSalesReps = createAsyncThunk(
	"updateSubChannelSalesReps",
	async ({ channel_id, subchannel_id, sales_reps, sales_reps_new, sales_reps_existing }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.put(`/channel/${channel_id}/sub_channel/${subchannel_id}/sales_reps`, {
				sales_reps,
				sales_reps_new,
				sales_reps_existing,
			});
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			return rejectWithValue(err.response.data);
		}
	}
);

const UpdateSubChannelSalesRepsSlice = createSlice({
	name: "UpdateSubChannelSalesRepsSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetUpdateSubChannelSalesRepsState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(updateSubChannelSalesReps.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(updateSubChannelSalesReps.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(updateSubChannelSalesReps.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetUpdateSubChannelSalesRepsState } = UpdateSubChannelSalesRepsSlice.actions;
export default UpdateSubChannelSalesRepsSlice.reducer;
